import { Link } from "react-router-dom";
import "../css/footer.css";

const LOGO_URL = "https://assets.igcprintingpress.com/public%20assets/igc-mark.svg";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <img
                src={LOGO_URL}
                alt="IGC Print Press"
                className="footer-logo-img"
              />
            </div>
            <p className="footer-desc">
              Premium commercial and creative print production house in Port
              Harcourt. Bringing family heritage and precision engineering to
              every page since 2018.
            </p>
          </div>

          <div className="footer-col">
            <h3 className="footer-heading">Sitemap</h3>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/services">Services</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/quote">Start a Print Job</Link>
          </div>

          <div className="footer-col">
            <h3 className="footer-heading">Policies</h3>
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/refund-policy">Refund Policy</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/faqs">FAQs</Link>
            <Link to="/delivery-policy">Delivery Policy</Link>
          </div>

          <div className="footer-col footer-address">
            <h3 className="footer-heading">Port Harcourt Pressroom</h3>
            <p>
              CBU Mall, Igwuruta, Along Eneka Road
              <br />
              Port Harcourt, Rivers State, Nigeria
            </p>
            <p>+234 803 773 8028</p>
            <p>support@igcprintinpress.com</p>
          </div>
        </div>

        <div className="footer-line" />

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} IGC Print Press. All rights reserved.</p>
          <p>Made with Pride in Nigeria</p>
        </div>
      </div>
    </footer>
  );
}